
<div class="agpr-brandCompetitors">
    <div class="agpr-brandCompetitors-header">
        <span class="agpr-brandCompetitors-header-label">
            <label>
                {{ label | localize }}
            </label>
            @if (infoTooltip) {
                <span
                    role="img"
                    class="fa-regular fa-circle-info"
                    [agprTooltip]="infoTooltip"
                ></span>
            }
        </span>
            <agpr-button
                [id]="id + '_add'"
                [style]="buttonTypes.icon"
                [icon]="'fa-regular fa-duotone fa-square-plus'"
                (click)="addCompetitor()"
                [tooltip]="'Common.brandInformation.competitors.add'"
                [tooltipPosition]="tooltipPosition"
                [disabled]="disabled || (hasEmptyCompetitors && _value.length > 0) || _value.length >= maxLimit"
            ></agpr-button>
    </div>

    @if (_value?.length) {
        <ul
            id="competitorList"
            class="agpr-brandCompetitors-list"
            agprListKeyboardNavigation
            [list]="_value"
            cdkDropList
            [cdkDropListData]="_value"
            [cdkDropListConnectedTo]="['brandList']"
            (cdkDropListDropped)="drop($event)"
        >
            @for (competitor of _value; track $index; let i = $index;) {
                <li class="agpr-brandCompetitors-listItem agpr-contextMenu-parent">
                    @if (competitor.value?.brand) {
                        <div class="agpr-brandCompetitors-listItem-brandCard">
                            <agpr-brand-identity-card
                                [id]="id + '_brandCompetitors_brandCard_' + i"
                                [brand]="competitor.value.brand"
                                [showBorder]="false"
                            ></agpr-brand-identity-card>
                        </div>
                    } @else {
                        <div class="agpr-brandCompetitors-listItem-brandName">
                            <agpr-autocomplete
                                [id]="id + '_nameInput_' + i"
                                class="agpr-brandCompetitors-listItem-brandNameAutocomplete"
                                [ariaLabel]="'Common.brandInformation.competitors.placeholder'"
                                [placeholder]="'Common.brandInformation.competitors.placeholder' | localize"
                                [suggestions]="suggestions$"
                                labelField="label"
                                [maxLength]="256"
                                [ngModel]="competitor"
                                (ngModelChange)="onCompetitorChange($event, competitor)"
                                [forceSelection]="false"
                                [clearOnBlur]="false"
                                [disabled]="disabled"
                            ></agpr-autocomplete>
                        </div>
                    }
                    @if (_value.length > 1 || competitor.label) {
                        <div class="agpr-contextMenu top right">
                            @if (_value.length) {
                                <agpr-button
                                    [id]="id + '_remove_' + i"
                                    [style]="buttonTypes.contextMenu"
                                    [icon]="'fa-regular fa-duotone fa-square-xmark'"
                                    [tooltip]="'Common.brandInformation.competitors.remove'"
                                    [tooltipPosition]="tooltipPosition"
                                    (click)="removeCompetitor(i)"
                                    [disabled]="disabled"
                                ></agpr-button>
                            }
                            @if (!hideItemActions) {
                                @if (competitor.value?.brand) {
                                    <agpr-button
                                        [id]="id + '_edit_' + i"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-file-pen'"
                                        [tooltip]="'Common.brandInformation.competitors.edit'"
                                        [tooltipPosition]="tooltipPosition"
                                        (click)="editCompetitor(competitor)"
                                        [disabled]="disabled"
                                    ></agpr-button>
                                } @else if (competitor.label) {
                                    <agpr-button
                                        [id]="id + '_create_' + i"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-file-circle-plus'"
                                        [tooltip]="'Common.brandInformation.competitors.create'"
                                        [tooltipPosition]="tooltipPosition"
                                        (click)="createBrand(competitor)"
                                        [disabled]="disabled"
                                    ></agpr-button>
                                }
                            }
                        </div>
                    }
                </li>
                @if (competitor.value?.errors?.competitorExists) {
                    <agpr-form-message
                        [id]="id + '_error_competitorExists'"
                        class="agpr-brandCompetitors-errorMessage"
                        [marginBottom]="0"
                    >
                        {{ 'Common.brandInformation.competitors.error.competitorExists' | localize: { name: competitor.label } }}
                    </agpr-form-message>
                }
            }
        </ul>
    } @else {
        <agpr-message
            [id]="id + '_noColorsMessage'"
            class="agpr-brandCompetitors-noCompetitorsMessage"
            [severity]="messageSeverity.noContent"
            [bottomMargin]="false"
        >
            {{ 'Common.brandInformation.competitors.noCompetitorsMessage' | localize}}
        </agpr-message>
    }
</div>



